<div class="do-button-container">
  <div class="button-wrapper">
    <button (click)="performAction()" [class]="buttonClass" [class.cl-btn-spinner]="_processing" [disabled]="_processing || disabled">
      <ng-content></ng-content>
    </button>
  </div>
</div>
